export default "__VITE_ASSET__C7WjOR_2__"